import React from 'react';

const Placeholder = ({ children = '' }) => (
  <div className="ws-ui-language-select-placeholder">{children}</div>
);

export default Placeholder;
